import {
  SET_CURRENT_USER,
  SET_CURRENT_PERMISSION,
  UPDATE_AUTH0_LOADING,
  UPDATE_AUTH0_USER,
  UPDATE_TOKEN,
  UPDATE_GET_ALL_TOKEN_LOADING,
  LOGOUT,
} from '../actions/types';

const initialState = {
  auth0loading: false,
  auth0user: {},
  me: {},
  permissions: {},
  modulesViewAll: {},
  getAllTokenLoading: true,
  token: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        me: action.me,
      };
    case SET_CURRENT_PERMISSION:
      return {
        ...state,
        permissions: action.payload.userModules,
        modulesViewAll: action.payload.companyModules,
      };
    case UPDATE_AUTH0_LOADING:
      return {
        ...state,
        auth0loading: action.auth0loading,
      };

    case UPDATE_AUTH0_USER:
      return {
        ...state,
        auth0user: action.auth0user,
      };
    case UPDATE_GET_ALL_TOKEN_LOADING:
      return {
        ...state,
        getAllTokenLoading: action.loading,
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        token: { ...state.token, ...action.payload },
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
